<ix-layout-grid columns="12" class="h-100 d-flex flex-column">
  <ix-row>
    <ix-col size="12">
      <ix-content-header
        headerTitle="{{ 'overview.menu.data_requests' | translate }}"
        id="listRemovedPassesHeader"
      ></ix-content-header>
    </ix-col>
  </ix-row>

  @if (loading) {
    <ix-row>
      <ix-col class="d-flex flex-row justify-content-center">
        <ix-spinner size="large"></ix-spinner>
      </ix-col>
    </ix-row>
  }

  @if (!loading) {
    <ix-row class="flex-grow-1">
      <ix-col size="12" class="h-100">
        <div [class.empty-dataset]="rowData.length === 0" class="ag-grid-container">
          <ag-grid-angular
            (gridReady)="onGridReady($event)"
            (rowClicked)="onRowClicked($event.data?.passportId)"
            [columnDefs]="columnDefs"
            [gridOptions]="gridOptions"
            [rowData]="rowData"
            [suppressCellFocus]="true"
            class="w-100 h-100"
            id="dataProviderAssignmentTable">
          </ag-grid-angular>
        </div>

        @if (rowData.length === 0) {
          <ix-empty-state
            header="{{ 'battery_pass.list.no_data_provision_available' | translate }}"
            icon="add"
            subHeader="{{ 'battery_pass.list.no_data_provision_text' | translate }}">
          </ix-empty-state>
        }
      </ix-col>
    </ix-row>
  }
</ix-layout-grid>
